<!-- Media Segments Indicator -->
@if (shouldShow()) {
  <div class="segments-container">
    @for (segmentIndex of getSegments(); track segmentIndex) {
      <div
          class="segment"
          [class.current]="isCurrentSegment(segmentIndex)"
          (click)="onSegmentClick($event, segmentIndex)">
      </div>
    }
  </div>
}
